import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class AppConfig {
    settings!: IAppConfig;
    constructor(private http: HttpClient) { }
    load(): Observable<IAppConfig> {
        const jsonFile = `assets/config/appconfig.json`;
        // The X-Requested-With header is required by the IIS rewrite rule in
        // Web.config that blocks direct browser address-bar access to this file.
        const headers = new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' });
        return this.http.get<IAppConfig>(jsonFile, { headers }).pipe(tap((response: IAppConfig) => {
            this.settings = response;
        }))
    };
}

export interface IAppConfig {
    ccaName: string,
    defaultURL: string,
    appInsightsKey: string,
}
